import { render } from "./ComponentUpgradeModal.vue?vue&type=template&id=6d8f38a2&scoped=true"
import script from "./ComponentUpgradeModal.vue?vue&type=script&lang=js"
export * from "./ComponentUpgradeModal.vue?vue&type=script&lang=js"

import "./ComponentUpgradeModal.vue?vue&type=style&index=0&id=6d8f38a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8f38a2"]])

export default __exports__